// @flow

import type {
  CheckoutEvent,
  EventAction,
  EventActionCreator,
  EventHandler,
} from 'redux/middleware/googleTagManager/types';

import {EVENT_LEADS} from 'redux/middleware/googleTagManager/actionTypes';
import {GTM_EVENT_CHECKOUT} from 'redux/middleware/googleTagManager/eventNames';

type Payload = {
  event_action: string,
  non_interaction: boolean,
  checkout_step: string,
  event_category: string,
};

type Action = EventAction<Payload>;

export const action: EventActionCreator<Action, Payload> = (
  payload: Payload
) => ({
  type: EVENT_LEADS,
  payload,
});

export const handler: EventHandler<Action, CheckoutEvent> = (
  action: Action
) => ({
  event: GTM_EVENT_CHECKOUT,
  event_action: action.payload.event_action,
  checkout_step: action.payload.checkout_step,
  event_category: action.payload.event_category,
  non_interaction: action.payload.non_interaction,
});
